const React = require("react");
const {openPopupWindow} = require("../../../../../../../emitters/popup");
const {apiAdminCustomerRefundAdd} = require("../../../../../../../api/admin/refunds");
const RefundForm = require('../components/RefundForm');

module.exports = (update) => openPopupWindow((setPopupState, popup) => {
  return (stateOfPopup) => {
    return (
      <RefundForm
        caption="Create Refund"
        state={stateOfPopup}
        setState={setPopupState}
        update={update}
        close={popup.close}
        onSave={(params) => {
          return apiAdminCustomerRefundAdd(params);
        }}
      />
    )
  }
})
